import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "./actions.js";
import { getEcosettingsValueByKey } from "../serviceSelectors";
import { restClient, realtimeClient } from "client-app-core";

const HealthService = () => {
	const dispatch = useDispatch();
	const {
		startHealthPolling,
		startNodeStatusPolling,
		logDataReceived,
		systemHealthConnectedChanged,
		systemHealthOnlineChanged
	} = actionCreators;

	const clusterHealthEnabled = useSelector(
		(state) => getEcosettingsValueByKey(state)("clusterHealthEnabled") || false
	);

	const nodeStatusPingInterval = useSelector(
		(state) => getEcosettingsValueByKey(state)("nodeStatusPingInterval") || 1000
	);

	useEffect(() => {
		if (realtimeClient._connected) {
			dispatch(systemHealthConnectedChanged(true));
		}
		if (realtimeClient._isOffline) {
			dispatch(systemHealthOnlineChanged(false));
		}

		restClient.on("dataReceived", (bytes) => {
			dispatch(logDataReceived(bytes));
		});
		realtimeClient.on("dataReceived", (bytes) => {
			dispatch(logDataReceived(bytes));
		});
		realtimeClient.on("connected", () => {
			dispatch(systemHealthConnectedChanged(true));
		});
		realtimeClient.on("disconnected", () => {
			dispatch(systemHealthConnectedChanged(false));
		});
		realtimeClient.on("online", () => {
			dispatch(systemHealthOnlineChanged(true));
		});
		realtimeClient.on("offline", () => {
			dispatch(systemHealthOnlineChanged(false));
		});

		dispatch(startHealthPolling());
	}, []);

	useEffect(() => {
		if (clusterHealthEnabled) {
			dispatch(startNodeStatusPolling(nodeStatusPingInterval));
		}
	}, [clusterHealthEnabled]);

	return <Fragment />;
};

export default HealthService;
